import { Typography } from "@/components";
import { BackAppBar } from "@/components/ui";
import useDeviceDetection from "@/hooks/useDeviceDetection";
import { DOWNLOAD_LINKS } from "@/libraries/constant";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import Button from "@mui/material/Button";
import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";

export const Route = createFileRoute("/dashboard/contacts/no-access")({
	component: RouteComponent,
});

function RouteComponent() {
	const { platform } = useDeviceDetection();

	const downloadLink = useMemo(() => {
		if (platform === "iOS" || platform === "MacOS") {
			return DOWNLOAD_LINKS.APP_STORE;
		}
		return DOWNLOAD_LINKS.PLAY_STORE;
	}, [platform]);

	return (
		<div className="relative h-full bg-white flex flex-col">
			<BackAppBar />
			<div className="container space-y-5">
				<Typography fontWeight={600} fontSize={28}>
					Connect securely with your colleagues
				</Typography>
				<Typography fontWeight={400} fontSize={14}>
					Allow HEMI Teams to access your phone contacts and then invite
					clinical colleagues to your HEMI Teams network.
				</Typography>
				<div className="bg-danger-100 w-full flex items-start border border-danger-300 rounded-xl gap-2 p-4">
					<ErrorRoundedIcon className="text-danger-300 !text-base" />
					<div>
						<p className="text-xs !leading-4 text-dark">
							Contact Access Unavailable. Contact features are only available in
							our mobile app.
						</p>
					</div>
				</div>
				<Button
					variant="contained"
					size="large"
					color="primary"
					fullWidth
					className="uppercase !rounded-full"
				>
					<a
						href={downloadLink}
						target="_blank"
						rel="noopener noreferrer"
						className="w-full"
					>
						Download App
					</a>
				</Button>
			</div>
		</div>
	);
}
